import { render, staticRenderFns } from "./EntitlementEdit.vue?vue&type=template&id=a989f8b0&"
import script from "./EntitlementEdit.vue?vue&type=script&lang=ts&"
export * from "./EntitlementEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a989f8b0')) {
      api.createRecord('a989f8b0', component.options)
    } else {
      api.reload('a989f8b0', component.options)
    }
    module.hot.accept("./EntitlementEdit.vue?vue&type=template&id=a989f8b0&", function () {
      api.rerender('a989f8b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entitlements/EntitlementEdit.vue"
export default component.exports